<template>
  <v-dialog v-model="show" hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Profesionales</v-toolbar-title>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="this.listaCronogramas"
        group-by="profesional"
        class="elevation-1 tabla"
        locale="es-ar"
        :items-per-page="10000"
        :hide-default-footer="true"
        item-key="idCronograma"
        :disable-sort="true"
      >
      </v-data-table>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.stop="show = false">Salir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import axios from "../axios-auth";

export default {
  data: (vm) => ({
    listaCronogramas: [],
    headers: [
      { text: "Día", value: "dia" },
      { text: "Profesional", value: "profesional" },
      { text: "Especialidad", value: "especialidad" },
      { text: "Hora Desde", value: "horaDesde" },
      { text: "Hora Hasta", value: "horaHasta" },
    ],
  }),
  computed: {
    show: {
      get() {
        if (this.visible) this.cargarCronogramas();
        return this.visible;
      },
      set(value) {
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.listaCronogramas = [];
          this.$emit("close");
        }
      },
    },
  },
  props: ["visible", "idInstitucion"],
  methods: {
    cargarCronogramas() {
      const datosCronograma = {
        idInstitucion: this.idInstitucion,
      };
      let self = this;
      axios
        .get("/Institucional/ConsultarCronogramasInstitucion?", {
          params: {
            idInstitucion: datosCronograma.idInstitucion,
          },
        })
        .then((response) => {
          self.listaCronogramas = response.data;
        })
        .catch((error) => {
          self.listaCronogramas = [];
        });
    },
  },
};
</script>
<style scoped>
.tabla {
  max-height: 525px;
  overflow-y: auto;
}
::v-deep .tabla thead {
  background-color: #000 !important;
}
::v-deep .tabla thead th {
  color: #fff !important;
}
::v-deep .tabla .v-row-group__header {
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
}
::v-deep .tabla .v-row-group__header:hover {
  background-color: rgba(0, 0, 0, 0.65) !important;
}
::v-deep .tabla .v-row-group__header .v-btn--flat:last-child {
  visibility: hidden;
}
::v-deep .tabla .v-row-group__header td {
  text-transform: capitalize;
}
::v-deep .tabla .v-row-group__header td .v-icon::before {
  color: #fff;
  content: "\F0140" !important;
}
</style>
